document.addEventListener('alpine:init', () => {
  Alpine.store('tag', {
    value: [],
    basePath: '',
    init() {
      let url = new URL(window.location.href);
      this.basePath = url.pathname.split('tagged/')[0];
      let tags = url.pathname.split('tagged/');
      if (tags.length > 1) {
        this.value = url.pathname.split('tagged/')[1].split('+');
      }
    },
    set(newValue) {
      if (newValue == null) {
        // newValue == null will only occur when the "View all is clicked"
        this.value = [];
        this.update();
        return;
      }
      const index = this.value.indexOf(newValue);
      if (index !== -1) {
        this.value.splice(index, 1);
      } else {
        this.value.push(newValue);
      }
      this.update();
    },
    update() {
      let url = new URL(window.location.href);
      url.pathname = `${this.basePath}/${this.value.length ? 'tagged/' : ''}${this.value.join('+')}`;

      window.history.pushState(window.history.state, '', url.href);
      fetch(`${url.pathname}${url.search}`)
        .then((response) => response.text())
        .then((data) => {
          let html = document.createElement('div');
          html.innerHTML = data;
          document.querySelector('div.blog_list-wrapper').innerHTML =
            html.querySelector('div.blog_list-wrapper').innerHTML;
        });
    },
  });
});

document.addEventListener('DOMContentLoaded', (event) => {
  document.querySelectorAll('.blog_category-menu .button').forEach((element) => {
    element.addEventListener('mousemove', (event) => {
      const rect = element.getBoundingClientRect();

      const cursorX = event.clientX - rect.left;
      const cursorY = event.clientY - rect.top;

      const vectorX = cursorX - rect.width / 2;
      const vectorY = cursorY - rect.height / 2;

      const angleRadians = Math.atan2(vectorY, vectorX);
      let angleDegrees = angleRadians * (180 / Math.PI);
      angleDegrees = (angleDegrees + 90 + 360) % 360;

      element.style.setProperty('--rotate', `${angleDegrees}deg`);
    });
  });
});
